import React, { useState } from 'react';
import { handleNavigate } from '../utils/Utils';
import { useNavigate } from 'react-router-dom';

const Footer = ({labels}) => {

    const navigate = useNavigate();

    return (
        <footer onClick={() => handleNavigate(navigate, "/contact-us")} className="w-full text-black p-2 sm:h-[5vh] md:h-[5vh] lg:h-[5vh] xl:h-[6vh] flex justify-center fixed bottom-0 mt-[12%] font-gotham-rounded" style={{ backgroundColor: "#fdba14" }}>
            <div className="mx-4">{labels.contact}</div>
        </footer>
    );
}

export default Footer;
